<div class="d-flex align-items-center justify-content-between">
  <h4 class="title ms-2">Reviews</h4>
</div>
<div class="hashtags-container">
  <div class="hashtag-list-collection">
    <div class="hashtag-content-list">
      <div class="hashtag-info-text d-flex justify-content-between align-items-center">
        Reviews / {{ reviewsCount }}
      </div>
      <div class="line-container-users">
      </div>
      <table class="tid-table">
        <tr>
          <th class="fixed-width-column">#</th>
          <th>Date</th>
          <th class="fixed-name-column">Full Name</th>
          <th>Phone</th>
          <th class="fixed-email-width-column">Email</th>
          <th>Review made for</th>
          <th>Description</th>
          <th>Rating</th>
          <th class="fixed-width-column">Action</th>
        </tr>
        @for (row of reviews; track row; let index = $index; let even = $even) {
          <tr class="tid-data-row" [ngClass]="{'tid-even': even}">
            <td>{{ (page * size) + index + 1 }}</td>
            <td>{{ row.createdAt | date: 'dd/MM/yyyy' }}</td>
            <td>
              <label for="forImage" class="pointer-custom col-sm-12 d-flex align-items-center">
                <div id="forImage" class="col-sm-12 text-center image-div">
                  <img
                    [src]="row.userInfoResponse.profilePic ? userService.getImage(row.userInfoResponse.profilePic) : 'assets/svg/defaultUserIcon.svg'"
                    class="image-style" 
                    alt=""
                    (error)="row.userInfoResponse.profilePic = ''">
                </div>
                <span class="ms-2">{{ row.userInfoResponse.name + ' ' + row.userInfoResponse.surname }}</span>
              </label>
            </td>
            <td>{{ row.userInfoResponse.phoneNumber }}</td>
            <td>{{ row.userInfoResponse.email }}</td>
            <td>
              <a class="name-unique-code"
                 (click)="navigateToUserSinglePage(row.cardId)">
                {{ row.cardId }}
              </a>
            </td>
            <td>
              @if (row.reviewText && row.reviewText.length > 100) {
                @if (!row.showFullReview) {
                  <span>{{ row.reviewText | slice:0:100 }}...</span>
                } @else {
                  <span>{{ row.reviewText }}</span>
                }
                <a href="#" class="see-more-link" (click)="$event.preventDefault(); toggleReview(row)">
                  {{ row.showFullReview ? 'See less' : 'See more' }}
                </a>
              }
              @if (!row.reviewText || row.reviewText.length <= 100) {
                <span>{{ row.reviewText }}</span>
              }
            </td>
            <td>
              @if (row.rating > 0) {
                @for (star of [].constructor(row.rating); track $index) {
                  <svg width="18" height="17" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                       style="vertical-align: middle; margin-right: 2px;">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M15 0L10.8713 10.2551L0 11.077L8.31958 18.2369L5.72949 29L15 23.1702L24.2705 29L21.6802 18.2369L30 11.077L19.1287 10.2551L15 0Z"
                          fill="#12314F"/>
                  </svg>
                }
              }
            </td>
            <td>
              <div class="user-cards-subscription-type-container">
                <img src="assets/svg/delete.svg" alt="delete svg"
                     style="cursor:pointer; z-index:1000;"
                     (click)="$event.stopPropagation(); deleteReview(row.id)">
              </div>
            </td>
          </tr>
        }
      </table>
      <br>
      <div class="pagination">
        <a (click)="goToPage(page - 1)" [class.disabled]="page === 0">&laquo;</a>
        @for (p of getPageNumbers(); track p; let i = $index) {
          <a (click)="goToPage(i)" [class.active]="page === i">
            {{ i + 1 }}
          </a>
        }
        <a (click)="goToPage(page + 1)" [class.disabled]="page === totalPages - 1">&raquo;</a>
      </div>
    </div>
  </div>
</div>
